/**
 * @file IconUp Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-up',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.75}"
  >
    <g fill="${
      data.colorDesc[0]
    }" fill-rule="nonzero" transform="translate(4.5,6)">
      <g
        transform="translate(20.684094,16.882965) scale(1,-1) translate(-20.684094,-16.882965)"
      >
        <path
          d="M22.5 30.76593C23.32843 30.76593 24 31.4375 24 32.26593 24 33.00231 23.46937 33.61476 22.76963 33.74176L22.5 33.76593 1.5 33.76593C.67157 33.76593 0 33.09436 0 32.26593 0 31.52955.53063 30.91711 1.23037 30.7901L1.5 30.76593 22.5 30.76593ZM33.43962 0C34.176 0 34.78844.53063 34.91545 1.23037L34.93962 1.5 34.938 28.467 38.80378 24.57787C39.32263 24.05533 40.1307 23.99461 40.71673 24.39753L40.92509 24.57036C41.44763 25.08921 41.50834 25.89727 41.10542 26.48331L40.93259 26.69167 34.50402 33.1659C33.98257 33.69106 33.16963 33.74941 32.5834 33.34095L32.37521 33.1659 25.94664 26.69167C25.36293 26.10381 25.36629 25.15407 25.95414 24.57036 26.41137 24.11636 27.0875 24.01751 27.64007 24.27258L27.86832 24.40357 28.07545 24.57787 31.938 28.467 31.93962 1.5C31.93962.67157 32.61119 0 33.43962 0ZM22.5 15.76593C23.32843 15.76593 24 16.4375 24 17.26593 24 18.00231 23.46937 18.61476 22.76963 18.74176L22.5 18.76593 1.5 18.76593C.67157 18.76593 0 18.09436 0 17.26593 0 16.52955.53063 15.91711 1.23037 15.7901L1.5 15.76593 22.5 15.76593ZM22.5.76593C23.32843.76593 24 1.4375 24 2.26593 24 3.00231 23.46937 3.61476 22.76963 3.74176L22.5 3.76593 1.5 3.76593C.67157 3.76593 0 3.09436 0 2.26593 0 1.52955.53063.91711 1.23037.7901L1.5.76593 22.5.76593Z"
        />
      </g>
    </g>
  </g>
</svg>
`
);
